// extracted by mini-css-extract-plugin
export var box = "_1h-1";
export var checked = "_1h-2";
export var descriptionSpacer = "_1h-9";
export var disabled = "_1h-3";
export var icon = "_1h-6";
export var input = "_1h-0";
export var labelSpacer = "_1h-8";
export var medium = "_1h-5";
export var small = "_1h-4";
export var text = "_1h-7";